
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carriers",
      function () {
        return require("private-next-pages/carriers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carriers"])
      });
    }
  